import { patchUser } from 'api/api'

import _ from 'lodash'
import { createSlice } from '@reduxjs/toolkit'
import { getCityLink } from './cities'
import { fetchLocation } from 'api'

export const initialState = { user: null, userError: '', success: null }

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        userUpdated: (state, { payload }) => {
            return { ...state, user: { ...state.user, ...payload }, success: true }
        },
        failedRequest: (state, { payload }) => {
            return { ...state, userError: payload, success: false }
        },
        clearError: state => {
            return { ...state, userError: null }
        },
        clearSuccess: state => {
            //TODO Re-think and tidy these actions
            return { ...state, success: null }
        },
    },
})

const { actions, reducer } = userSlice // Extract the action creators object and the reducer
export default reducer

//Selectors
export const getUserError = store => store.user.userError
export const getUserSuccess = store => store.user.success

//Action creators
export const { failedRequest, userUpdated, clearError, clearSuccess } = actions

//Thunks
export function getErrorMessage(err) {
    let status = _.get(err, 'response.data.statusCode')
    return (
        (status >= 400 && status <= 499 && _.get(err, 'response.data.msg')) ||
        'Error encountered, please try again. If the problem persists please contact us.'
    )
}

export const withStructuredLocation = (rawBody, defaults) => async (_, getState) => {
    const body = { ...rawBody }

    const cityLink = getCityLink(getState(), body.location)

    if (cityLink) {
        const location = await fetchLocation(cityLink)

        body.country = location.country
        body.region = location.region
        body.city = location.city
    } else if (defaults && defaults.country && defaults.region && defaults.city) {
        body.country = defaults.country
        body.region = defaults.region
        body.city = defaults.city
    }

    delete body.location

    return body
}

export const updateUser = (newUser, oldUser) => async dispatch => {
    try {
        const body = await dispatch(withStructuredLocation(newUser, oldUser))

        await patchUser(body)

        dispatch(clearError())
    } catch (err) {
        console.error(err)
        dispatch(failedRequest(getErrorMessage(err)))
    }
}
